import { RowSelectionState } from '@tanstack/react-table'

export interface ISelectionScope {
  /** Rows loaded in the table so far - everything a selection can currently reach. */
  loaded: number
  /** Users matching the filters, loaded or not. */
  total: number
  viaSelectAll: boolean
}

export interface ISelectAllStillHoldsParams {
  wasSelectAll: boolean
  previous: RowSelectionState
  next: RowSelectionState
}

/** A selection made with the header's Select all stays one while every row it held is still
 * selected; unticking any row, or clearing, turns it into an ordinary selection. */
export function selectAllStillHolds(params: ISelectAllStillHoldsParams): boolean {
  const { wasSelectAll, previous, next } = params
  const held = Object.keys(previous).filter((id) => previous[id])
  return wasSelectAll && held.length > 0 && held.every((id) => next[id])
}

/** The "only the loaded users" note belongs to a Select all that could not reach everyone. Rows
 * ticked one by one never carry it: nobody ticking three rows thinks they ticked forty. */
export const showsLoadedOnlyNote = (scope?: ISelectionScope): boolean => Boolean(scope && scope.viaSelectAll && scope.loaded < scope.total)
